import { AddPartBom } from 'iframe/components';
import { IframePageLayout } from 'iframe/pages';

export const AddPartBomPage = () => {
  return (
    <IframePageLayout>
      <AddPartBom />
    </IframePageLayout>
  );
};
